module.exports = __webpack_public_path__ + "static/media/carta_85.b7c00b6c.jpg";